import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { TenantScopeProvider, useTenantScope } from '@/app/providers/TenantScopeProvider';
import { buildScopedPath } from '@/app/routes';
import { auth } from '@/shared/auth/storage';
import { setApiActiveScope } from '@/shared/api/client';
import { publicRoutes } from '@/app/routes';
import { NAV } from './NavConfig';

function ThemeToggle() {
  const toggle = () => {
    const cur = document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-bs-theme', cur);
    localStorage.setItem('ts-theme', cur);
  };
  return (
    <button className="ts-btn ts-btn-ghost" onClick={toggle} title="Загвар">
      <i className="bi bi-circle-half" />
    </button>
  );
}

function Sidebar() {
  const scope = useTenantScope();
  const nav = useNavigate();
  const loc = useLocation();
  return (
    <aside className="cg-sidebar">
      <div className="cg-brand">
        <i className="bi bi-truck-front" />
        TseTsu Карго
      </div>
      {NAV.map((item, i) => {
        if (item.kind === 'section')
          return (
            <div key={i} className="cg-nav-section">
              {item.label}
            </div>
          );
        const href = buildScopedPath(item.routeKey!, scope);
        const active = loc.pathname === href || loc.pathname.startsWith(href + '/');
        return (
          <div
            key={i}
            className={`cg-nav-item ${active ? 'active' : ''} ${item.accent ? 'accent' : ''}`}
            onClick={() => nav(href)}
          >
            <i className={`bi ${item.icon}`} />
            {item.label}
          </div>
        );
      })}
    </aside>
  );
}

function Header() {
  const scope = useTenantScope();
  const nav = useNavigate();
  const logout = () => {
    auth.clear();
    setApiActiveScope(null);
    nav(publicRoutes.login, { replace: true });
  };
  return (
    <header className="cg-header">
      <div className="ts-flex-row">
        <i className="bi bi-building" style={{ color: 'var(--ts-brand)' }} />
        <strong>{scope.companyName || '—'}</strong>
        <span style={{ color: 'var(--ts-muted)', fontSize: '0.82rem' }}>· {scope.tenantName}</span>
      </div>
      <div className="ts-flex-row">
        <button className="ts-btn ts-btn-ghost" onClick={() => nav(publicRoutes.selectScope)} title="Байгууллага солих">
          <i className="bi bi-arrow-left-right" />
        </button>
        <ThemeToggle />
        <span style={{ color: 'var(--ts-muted)', fontSize: '0.85rem' }}>{auth.displayName}</span>
        <button className="ts-btn ts-btn-ghost" onClick={logout} title="Гарах">
          <i className="bi bi-box-arrow-right" />
        </button>
      </div>
    </header>
  );
}

function Frame() {
  return (
    <div className="cg-shell">
      <Sidebar />
      <div className="cg-main">
        <Header />
        <div className="cg-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export function ShellLayout() {
  if (!auth.isAuthed) {
    window.location.replace(publicRoutes.login);
    return null;
  }
  return (
    <TenantScopeProvider>
      <Frame />
    </TenantScopeProvider>
  );
}
